import {useState} from 'react';

const prefix = `id_${Date.now().toString(36)}_`;

let j = 0;

const useUniqueId = () => useState(() => prefix + ++j )[0];

export default useUniqueId;
